import React from "react";
import "../styles/Slider.css";
import Carousel from "react-bootstrap/Carousel";

function Slider({val}) {
  return (
    <>
      <div
        id="template-mo-zay-hero-carousel"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <Carousel>
          {val.map((val) => {
            return (
              <Carousel.Item interval={1000} key={val.id}>
                <div className="container">
                  <div className="row p-5">
                    <div className="mx-auto col-md-8 col-lg-6 order-lg-last">
                      <img className="img-fluid" src={val.imgS} alt="" />
                    </div>
                    <div className="col-lg-6 mb-0 d-flex align-items-center">
                      <div className="text-align-left align-self-center">
                        <h1 className="h1 text-success">{val.Title}</h1>
                        <h3 className="h2">{val.Subtitle}</h3>
                        <p>{val.Description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
    </>
  );
}

export default Slider;
